import { StandardComplianceScoreType } from '../../store/Models/SharedMaterials/DataModel';

export class SharedMaterialsReactUtilities {
    private static readonly complianceDeterminationToSpanClasses = {
        [StandardComplianceScoreType.Unknown]: "unknown glyphicon-question-sign",
        [StandardComplianceScoreType.Compliant]: "compliant glyphicon-ok-sign",
        [StandardComplianceScoreType.NonCompliant]: "noncompliant glyphicon-remove-sign",
    };

    public static getComplianceIconForComplianceDetermination(determination: StandardComplianceScoreType | null | undefined): JSX.Element {
        if (determination === null || determination === undefined) {
            return <span></span>;
        }

        const classes = this.complianceDeterminationToSpanClasses[determination];

        return (
            <span className={"compliance-tag glyphicon " + classes}></ span>
        );
    }
}